var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSavingsIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Homeowner-mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Onboarding-Step-2",
    transform: "translate(-74.000000, -370.000000)",
    className: "premiumIcon",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(74.000000, 370.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.36,15.36 L15.36,9.92 C14.0757333,10.2358528 13.12,11.330057 13.12,12.64 C13.12,13.949943 14.0757333,15.0441472 15.36,15.36 Z",
    id: "Fill-3387"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.64,22.08 C17.9242667,21.7640653 18.88,20.6695774 18.88,19.3592948 C18.88,18.0490122 17.9242667,16.9545242 16.64,16.64 L16.64,22.08 Z",
    id: "Fill-3388"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.173913,19.4782609 C20.173913,21.5415652 18.6657391,23.2486957 16.6956522,23.5812174 L16.6956522,25.0434783 C16.6956522,25.4274783 16.384,25.7391304 16,25.7391304 C15.616,25.7391304 15.3043478,25.4274783 15.3043478,25.0434783 L15.3043478,23.5812174 C13.3342609,23.2486957 11.826087,21.5415652 11.826087,19.4782609 C11.826087,19.0942609 12.1377391,18.7826087 12.5217391,18.7826087 C12.9057391,18.7826087 13.2173913,19.0942609 13.2173913,19.4782609 C13.2173913,20.7707826 14.1078261,21.8504348 15.3043478,22.162087 L15.3043478,16.6246957 C13.3342609,16.2921739 11.826087,14.5850435 11.826087,12.5217391 C11.826087,10.4584348 13.3342609,8.75130435 15.3043478,8.41878261 L15.3043478,6.95652174 C15.3043478,6.57252174 15.616,6.26086957 16,6.26086957 C16.384,6.26086957 16.6956522,6.57252174 16.6956522,6.95652174 L16.6956522,8.41878261 C18.6657391,8.75130435 20.173913,10.4584348 20.173913,12.5217391 C20.173913,12.9057391 19.8622609,13.2173913 19.4782609,13.2173913 C19.0942609,13.2173913 18.7826087,12.9057391 18.7826087,12.5217391 C18.7826087,11.2292174 17.8921739,10.1495652 16.6956522,9.83791304 L16.6956522,15.3753043 C18.6657391,15.7078261 20.173913,17.4149565 20.173913,19.4782609 M0,16 C0,24.8222609 7.17773913,32 16,32 C24.8222609,32 32,24.8222609 32,16 C32,7.17773913 24.8222609,0 16,0 C7.17773913,0 0,7.17773913 0,16 Z",
    id: "Fill-3389"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSavingsIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/savings_icon.dce2395e44c71158a5d3801fc1de8312.svg";